import request, {GET} from "Utilities/Fetches";

const BASE = "/services/subject";

const LIST = BASE + "/list";


export function listAPI(callback) {
	request(LIST, GET, null, callback);
}